import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EffectivePolicySettingsDialogComponent } from '../effective-policy-settings-dialog/effective-policy-settings-dialog.component';
import { Platform } from 'src/app/models/api';
import {
  EffectivePolicySettingEnum,
  CategoryToRules,
} from 'src/app/services/infra/store/model/effectivePolicySetting.model';
import { StoreService } from 'src/app/services/infra/store/store.service';

@Component({
  selector: 'app-effective-policy-settings-button',
  templateUrl: './effective-policy-settings-button.component.html',
  styleUrls: ['./effective-policy-settings-button.component.scss'],
})
export class EffectivePolicySettingsButtonComponent implements OnInit, OnChanges {
  @Input() public effectivePolicySetting: EffectivePolicySettingEnum;
  @Input() public platform: Platform;
  @Output() public buttonClickedEventEmitter: EventEmitter<undefined> = new EventEmitter<undefined>();

  public isDisabled = false;
  public tooltipText = '';

  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _storeService: StoreService
  ) {}

  ngOnInit(): void {
    this._checkIfRulesAreEmpty();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['effectivePolicySetting'] || changes['platform']) {
      this._checkIfRulesAreEmpty();
    }
  }

  public buttonClicked() {
    if (this.isDisabled) {
      return;
    }
    this.buttonClickedEventEmitter.emit();
    this._openEffectivePolicySettingsDialog(this.effectivePolicySetting, this.platform);
  }

  private _checkIfRulesAreEmpty(): void {
    const effectivePolicySettingsData: CategoryToRules[] = this._storeService.getCategoryRulesByPlatformAndSettings(
      this.platform,
      this.effectivePolicySetting
    );

    const hasRules =
      effectivePolicySettingsData &&
      effectivePolicySettingsData.length > 0 &&
      effectivePolicySettingsData.some((category) => category.rulesSummary && category.rulesSummary.length > 0);

    this.isDisabled = !hasRules;
    this.tooltipText = this.isDisabled ? 'No available rules' : '';
  }

  private _openEffectivePolicySettingsDialog(
    effectivePolicySettingName: EffectivePolicySettingEnum,
    platform: Platform
  ) {
    this._matDialog.open(EffectivePolicySettingsDialogComponent, {
      data: {
        effectivePolicySettingName: effectivePolicySettingName,
        platform: platform,
      },
      disableClose: false,
      panelClass: 'sized-popup-dialog-container',
      width: '800px',
      maxHeight: '90vh',
    });
  }
}
